export enum LoopTrigger {
  Function = 'function',
  Interval = 'interval'
}
